import { render, staticRenderFns } from "./safe-config.vue?vue&type=template&id=bcaf8040&scoped=true&"
import script from "./safe-config.vue?vue&type=script&lang=js&"
export * from "./safe-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaf8040",
  null
  
)

export default component.exports